import { Reveal } from "./Reveal";
import { TIMELINE, HISTORIA_IMG } from "./data";
import { useContent } from "@/lib/useContent";

export const Historia = () => {
  const timeline = useContent("timeline", TIMELINE);
  return (
    <section id="historia" className="relative py-24 md:py-32 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-start">
          <Reveal className="lg:sticky lg:top-28">
            <span className="section-tag">Nuestra historia</span>
            <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-navy">
              50 años escribiendo<br className="hidden sm:block" /> nuestra propia historia
            </h2>
            <p className="mt-5 text-lg text-gray-600 leading-relaxed max-w-lg">
              Desde 1976, el Club Comandante Leo Nowak es mucho más que fútbol: es identidad, amistad y pertenencia para miles de familias.
            </p>
            <div className="mt-8 relative rounded-2xl overflow-hidden border border-gray-100 shadow-md">
              <img
                src={HISTORIA_IMG}
                alt="Foto histórica del club"
                loading="lazy"
                className="w-full h-64 object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-navy/70 to-transparent" />
              <span className="absolute bottom-4 left-5 text-white font-bold text-lg" style={{ fontFamily: "Outfit" }}>
                Los orígenes · 1976
              </span>
            </div>
          </Reveal>

          <div className="relative">
            <div className="absolute left-[15px] sm:left-[19px] top-2 bottom-2 w-0.5 bg-gradient-to-b from-navy via-gold to-navy/20" />
            <div className="space-y-10">
              {timeline.map((t, i) => (
                <Reveal key={t.year} delay={i * 0.06}>
                  <div className="relative pl-12 sm:pl-16">
                    <div className="absolute left-0 top-0 h-8 w-8 sm:h-10 sm:w-10 rounded-full bg-navy border-4 border-white shadow-md flex items-center justify-center">
                      <div className="h-2.5 w-2.5 rounded-full bg-gold" />
                    </div>
                    <span className="text-3xl sm:text-4xl font-extrabold text-gold tracking-tight" style={{ fontFamily: "Outfit" }}>
                      {t.year}
                    </span>
                    <h3 className="mt-1 text-xl font-semibold text-navy">{t.title}</h3>
                    <p className="mt-2 text-gray-600 leading-relaxed">{t.text}</p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
